import React, { Fragment } from 'react';
import T from 'prop-types';

const PayWall = ({ onClick }) => (
  <Fragment>
    <div className="paywall-column-sticky-container">
      <div className="paywall-column-sticky-item">
        <p className="text-quiet text-xxs m-b-xs">Data available with Apptopia subscription</p>
        <button className="btn btn-sm" onClick={onClick} data-dynamic-add-scroll-to-hubspot="true">
          Request a Demo
        </button>
      </div>
    </div>
  </Fragment>
);

PayWall.propTypes = {
  onClick: T.func.isRequired,
};
export default PayWall;
